module.exports = __webpack_public_path__ + "assets/media/favicon180.7e1cbf264587f6bf6d232bcd42a5451a.png";